import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import ArgonDashboard from "./argon-dashboard";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAndroid, faApple } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueClickAway from "vue3-click-away";


import './main.css'
library.add(fas, faAndroid, faApple)


const appInstance = createApp(App);
appInstance.config.performance = true;
appInstance.component('font-awesome-icon', FontAwesomeIcon)
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueClickAway)
appInstance.mount("#app");
